module.exports = __webpack_public_path__ + "static/media/Message-Outline.6a77db55.svg";